// Disposition system — complete overhaul per Phase 1 rules.
//
// Booked can ONLY be assigned by a Google Calendar confirmation
// (via the /calls/{id}/confirm-booking endpoint, or a calling-provider
// tool-call returning a calendar_event_id). The UI must NOT let admins
// manually click "Booked" — instead, use the "Confirm Booking" flow.

export const DISPOSITION_GROUPS = [
  {
    key: "positive",
    label: "Positive outcomes",
    items: [
      { value: "Booked", hint: "Appointment confirmed in Google Calendar", requiresCalendar: true },
      { value: "Got Email", hint: "Interested, couldn't book, collected email" },
      { value: "Hot Lead", hint: "Very interested, needs callback, phone only" },
    ],
  },
  {
    key: "negative",
    label: "Negative outcomes",
    items: [
      { value: "Not Interested", hint: "Prospect declined" },
      { value: "Voicemail", hint: "Left a voicemail" },
      { value: "No Answer", hint: "Phone rang, no pickup" },
      { value: "Hung Up", hint: "Prospect disconnected mid-call" },
      { value: "Wrong Business", hint: "Not the right business" },
      { value: "Asked for DNC", hint: "Prospect asked to be removed — auto-DNC", autoDnc: true },
    ],
  },
  {
    key: "system",
    label: "System errors",
    items: [
      { value: "Could Not Book — System Error, got email", hint: "Booking failed but email captured" },
      { value: "Could Not Book — System Error, phone only", hint: "Booking failed, no email" },
      { value: "Ghost Call", hint: "Call connected but no one spoke" },
      { value: "Disconnected", hint: "Call dropped unexpectedly" },
    ],
  },
];

export const DISPOSITIONS = DISPOSITION_GROUPS.flatMap((g) => g.items.map((i) => i.value));

// Color mapping (bg, text, border)
export const dispositionClass = (d) => {
  switch (d) {
    // GREEN — Positive
    case "Booked":
      return "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 font-semibold";
    case "Got Email":
      return "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20";
    case "Hot Lead":
      return "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20";
    // RED — Negative (firm)
    case "Not Interested":
    case "Wrong Business":
      return "bg-red-500/10 text-red-400 border border-red-500/20";
    case "Asked for DNC":
      return "bg-red-500/15 text-red-500 border border-red-500/30 font-semibold";
    // YELLOW — Missed / unresolved
    case "Voicemail":
    case "No Answer":
    case "Hung Up":
      return "bg-amber-500/10 text-amber-300 border border-amber-500/20";
    // ORANGE — System booking failures
    case "Could Not Book — System Error, got email":
    case "Could Not Book — System Error, phone only":
      return "bg-orange-500/10 text-orange-400 border border-orange-500/30";
    // GRAY — Technical no-ops
    case "Ghost Call":
    case "Disconnected":
      return "bg-zinc-500/10 text-zinc-400 border border-zinc-500/20";
    default:
      return "bg-white/5 text-white/40 border border-white/10";
  }
};

export const findDispositionMeta = (value) => {
  for (const g of DISPOSITION_GROUPS) {
    const m = g.items.find((i) => i.value === value);
    if (m) return { ...m, group: g.key };
  }
  return null;
};
